import ParameterStorage from "./parameter-storage";
import { clone } from "../utils";
import Parameter from "../singleton/parameter";
import ModuleCard from "../singleton/module-card";
import IModuleCard from "../interface/module-card";
import ParamStorage from "../enum/param-storage";
import ErrorCode from "../enum/error-code";
import CardType from "../enum/card-type";

class ModuleCardBase {

    public CardType: CardType = CardType.List;

    /* Public Methods */

    public async create(card: IModuleCard): Promise<IModuleCard> {
        if (this.valid(card)) {
            card.type = this.CardType;
            const result: IModuleCard = await this.getStore().create(this.toServer(await this.onCreate(card)));
            return ModuleCard.get(result.id as number) as IModuleCard;
        } else {
            throw ErrorCode.BadArguments;
        }
    }

    public async update(card: IModuleCard): Promise<IModuleCard> {
        const existed: IModuleCard | null = ModuleCard.get(card.id as number);
        if (this.valid(card) && existed) {
            await this.getStore().update(this.toServer(await this.onUpdate(card, existed)));
            return this.toClient(card) as IModuleCard;
        } else {
            throw ErrorCode.BadArguments;
        }
    }

    public async delete(id: number): Promise<number> {
        const card: IModuleCard | null = ModuleCard.get(id);
        if (card) {
            await this.onDelete(card);
            return await this.getStore().delete(id);
        }
        return id;
    }

    public async clone(original: IModuleCard): Promise<IModuleCard | null> {
        const card: IModuleCard = clone(original) as IModuleCard;
        delete card.id;
        return await this.getStore().create(this.toServer(await this.onClone(card)));
    }

    public async onCreate(card: IModuleCard): Promise<IModuleCard> {
        return card;
    }

    public async onUpdate(card: IModuleCard, existed: IModuleCard): Promise<IModuleCard> {
        return card;
    }

    public async onDelete(card: IModuleCard): Promise<void> { }

    public async onClone(card: IModuleCard): Promise<IModuleCard> {
        throw ErrorCode.NotImplemented;
    }

    public toServer(card: IModuleCard): IModuleCard {
        return card;
    }

    public toClient(card: IModuleCard): IModuleCard | null {
        return card;
    }

    public valid(card: IModuleCard): boolean {
        return !!card.moduleId;
    }

    public getListId(card: IModuleCard): number | null {
        return null;
    }

    private getStore(): ParameterStorage<IModuleCard> {
        return Parameter.get(ParamStorage.ModuleCards);
    }

}

export default ModuleCardBase;